/**
	判断是否微信环境
	@param 
	@return { Boolean } 是否微信环境
*/
function is_weixin() {  
    var ua = navigator.userAgent.toLowerCase();  
    if(ua.match(/MicroMessenger/i)=="micromessenger") {  
        return true;  
    } else {  
        return false;  
    }  
}



export {
	is_weixin
}


// WEBPACK FOOTER //
// ./src/components/utils.js